import { render, staticRenderFns } from "./Taxation.vue?vue&type=template&id=b4cb307e&scoped=true"
import script from "./Taxation.vue?vue&type=script&lang=js"
export * from "./Taxation.vue?vue&type=script&lang=js"
import style0 from "./Taxation.vue?vue&type=style&index=0&id=b4cb307e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4cb307e",
  null
  
)

export default component.exports